import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UnfinishedHttpMethodsService {
    protected subscriptionOfURLs: Map<string, Subscription>;

    previousUrl: string;
    
    constructor(public router: Router) {
        this.subscriptionOfURLs = new Map();
        this.previousUrl = this.router.url;

        router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          this.previousUrl = event.url;
        });
    }

    public waitForAll() {
        return new Promise((resolve) => this.checkFlagAll(resolve));
    }

    public addSubscription(subscription: Subscription) {
        this.subscriptionOfURLs.set(this.previousUrl, subscription);
    }

    public async waitByUrl(url: string) {
          return new Promise((resolve) => this.checkFlag(url, resolve));
    }

    protected checkFlag(url: string, resolve: any) {
        if (!this.subscriptionOfURLs || !this.subscriptionOfURLs.has(url) || (this.subscriptionOfURLs.get(url)?.closed)) {
            return resolve();
        } 
        else {
            setTimeout(() => {
                this.checkFlag(url, resolve);
            }, 300);
        }
    }

    protected checkFlagAll(resolve: any) {
        if (!this.subscriptionOfURLs || !Array.from(this.subscriptionOfURLs.values()).some(sub => !sub.closed) ) {
            return resolve();
        } 
        else {
            setTimeout(() => {
                this.checkFlagAll(resolve);
            }, 100);
        }
    }
}